import { Grid, Skeleton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { PaymentDistributionResponse } from '../models/paymentDistributionResponse';
import { StatisticsTitleAndValueRow } from './statisticsTitleAndValueRow';

type StatisticsPaymentDistributionContentProps = {
  paymentDistribution: PaymentDistributionResponse | undefined;
  isLoading: boolean;
};

export const StatisticsPaymentDistributionContent = (props: StatisticsPaymentDistributionContentProps) => {
  const { isLoading, paymentDistribution } = props;
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <>
        <Skeleton variant='text' sx={{ height: '40px', my: 1.5 }} />
        <Skeleton variant='text' sx={{ height: '40px', my: 1.5 }} />
        <Skeleton variant='text' sx={{ height: '40px', my: 1.5 }} />
        <Skeleton variant='text' sx={{ height: '40px', my: 1.5 }} />
      </>
    );
  }
  return (
    <>
      <Grid item xs={12}>
        <StatisticsTitleAndValueRow
          uppercase
          title={t('statistics:payments.labels.bankGiro')}
          value=''
          currencyValue={paymentDistribution?.bankgiroAmount ?? 0}
          divider
          py={1.5}
        />
      </Grid>
      <Grid item xs={12}>
        <StatisticsTitleAndValueRow
          uppercase
          title={t('statistics:payments.labels.swish')}
          value=''
          currencyValue={paymentDistribution?.swishAmount ?? 0}
          divider
          py={1.5}
        />
      </Grid>
      <Grid item xs={12}>
        <StatisticsTitleAndValueRow
          uppercase
          title={t('statistics:payments.labels.card')}
          value=''
          currencyValue={paymentDistribution?.cardAmount ?? 0}
          divider
          py={1.5}
        />
      </Grid>
      <Grid item xs={12}>
        <StatisticsTitleAndValueRow
          uppercase
          title={t('statistics:payments.labels.checkout')}
          value=''
          currencyValue={paymentDistribution?.cashAmount ?? 0}
          divider
          py={1.5}
        />
      </Grid>
    </>
  );
};
